/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Late_Coyote_ScoldInputs */

const fr_home_late_coyote_scold = /** @type {(inputs: Home_Late_Coyote_ScoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine suivante`)
};

/**

* @param {Home_Late_Coyote_ScoldInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const home_late_coyote_scold = /** @type {((inputs?: Home_Late_Coyote_ScoldInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Late_Coyote_ScoldInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_home_late_coyote_scold(inputs)
});